import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const CopyIcon = (props: IconProps) => (
  <Icon width="16px" height="16px" viewBox="0 0 16 16" {...props}>
    <path d="M10.707.667h-8c-.734 0-1.334.6-1.334 1.333v9.333h1.334V2h8V.667Zm2 2.666H5.373c-.733 0-1.333.6-1.333 1.334V14c0 .733.6 1.333 1.333 1.333h7.334c.733 0 1.333-.6 1.333-1.333V4.667c0-.734-.6-1.334-1.333-1.334Zm0 10.667H5.373V4.667h7.334V14Z" />
  </Icon>
);

export default memo(CopyIcon);
